/**
 * BACHGOLD PDP VIDEO STRIP
 * ---------------------------------------------------
 * - Videos starten gepaused (Poster sichtbar)
 * - Click auf Card: spielt mit Ton ab (unmuted)
 * - Nur 1 Video spielt gleichzeitig — Click auf andere Card
 *   pausiert die laufende
 * - Click auf laufende Card: pausiert sie
 * - Progress-Bar synct mit horizontal Scroll-Position des Tracks
 */
(function () {
  'use strict';

  function initVideoStrip(section) {
    var track = section.querySelector('[data-videostrip-track]');
    var progress = section.querySelector('[data-videostrip-progress]');
    var cards = section.querySelectorAll('[data-videostrip-card]');

    if (!track) return;

    /* Progress-Bar Sync */
    function updateProgress() {
      if (!progress) return;
      var scrollable = track.scrollWidth - track.clientWidth;
      if (scrollable <= 0) {
        progress.style.width = '100%';
        return;
      }
      var ratio = track.scrollLeft / scrollable;
      var minWidth = Math.min(35, (track.clientWidth / track.scrollWidth) * 100);
      var widthPercent = minWidth + ratio * (100 - minWidth);
      progress.style.width = widthPercent + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();

    function pauseAllExcept(currentCard) {
      cards.forEach(function (other) {
        if (other === currentCard) return;
        var v = other.querySelector('video');
        if (v && !v.paused) {
          v.pause();
        }
        other.removeAttribute('data-playing');
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;

      /* sync data-playing flag with native events
         (covers natural end, manual pause via controls, etc.) */
      video.addEventListener('play', function () {
        card.setAttribute('data-playing', 'true');
      });
      video.addEventListener('pause', function () {
        card.removeAttribute('data-playing');
      });
      video.addEventListener('ended', function () {
        card.removeAttribute('data-playing');
      });

      card.addEventListener('click', function (e) {
        /* Wenn click auf native video-controls geht (sliders etc),
           nichts unterbrechen — aber wir haben keine controls drauf. */
        if (!video.paused) {
          /* Bereits am Spielen → pause */
          video.pause();
          return;
        }

        /* Pausiere alle anderen */
        pauseAllExcept(card);

        /* Mit Ton starten */
        video.muted = false;
        video.volume = 1;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            /* Fallback: manche Browser blocken unmuted-play
               wenn der vorherige Click-Event-Loop schon vorbei ist.
               Dann muted starten als Notfall. */
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.bb-pdp-videostrip');
    sections.forEach(initVideoStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init on Shopify section reload (Theme Editor) */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.bb-pdp-videostrip');
    if (section) initVideoStrip(section);
  });
})();
